
document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.video-box');
    function pauseAll(exceptVideo = null) {
    items.forEach(item => {
      const v = item.querySelector('video');
      if (!v) return;
      if (v !== exceptVideo) {
        v.pause();
      }
    });
  }
    items.forEach(item => {
    const video = item.querySelector('video');
    const start_play = item.querySelector('.start-play');
    const playBtn = item.querySelector('.button-row__btn');

    if (!video || !start_play || !playBtn) return;
    function togglePlay(e) {
      e?.stopPropagation();

       if (!video.paused && !video.ended) {
        video.pause();
        start_play.style.display = 'flex';
        return;
      } 
      
      pauseAll(video);
      video.play();
      start_play.style.display = 'none';
      
      
    }

    video.addEventListener('click', togglePlay);
    playBtn.addEventListener('click', togglePlay);

     video.addEventListener('pause', function() {
      start_play.style.display = 'flex';
    });

     video.addEventListener('play', function() {
       start_play.style.display = 'none';
    });  

  });

  
})